export default __webpack_public_path__ + "static/Effective Ways to Learn Chinese-01-f6e6a8a7cfe3a89096b05931f3382b85.jpg";